import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import RedirectToStoredPathname from '../elements/storedPathname/RedirectToStoredPathname';
import UnauthenticatedRedirection from '../elements/storedPathname/UnauthenticatedRedirection';
import I18nSwitcher from '../I18nSwitcher';
import LoadUpdates from '../loaders/LoadUpdates';
import LoadUserEvents from '../loaders/LoadUserEvents';
import AddEventCode from '../screens/AddEventCode';
import AddEventWithCode from '../screens/AddEventWithCode';
import Archive from '../screens/Archive';
import LinkedinNewAccount from '../screens/authentication/LinkedinNewAccount/LinkedinNewAccount';
import Login from '../screens/authentication/Login';
import LoginViaEmail from '../screens/authentication/LoginViaEmail';
import LoginViaLinkedin from '../screens/authentication/LoginViaLinkedin';
import MissingCode from '../screens/authentication/MissingCode';
import NewAccount from '../screens/authentication/NewAccount';
import PasswordRecover from '../screens/authentication/PasswordRecover';
import Registration from '../screens/authentication/Registration';
import Welcome from '../screens/authentication/Welcome';
import GetMost from '../screens/GetMost';
import MainScreen from '../screens/MainScreen';
import MyProfileScreen_Edit from '../screens/MyProfile/MyProfileScreen_Edit';
import MyProfileScreen_Email from '../screens/MyProfile/MyProfileScreen_Email';
import PrivacyStatement from '../screens/PrivacyStatement';
import UserAgreement from '../screens/UserAgreement';
import SidePanel from '../sidepanel/SidePanel';
import StyleVariables from '../StyleVariables/StyleVariables';
import eventRoutes from './EventRouter';
import globalChatRoutes from './globalChatRoutes';
import globalContactsRoutes from './globalContactsRoutes';
import notificationRoutes from './notificationRoutes';
import profileRoutes from './profileRoutes';

class AppRoutes extends React.Component {
    componentDidMount() {
        this.unlistenHistory = app.history.listen(this.handleRouteChange.bind(this));
    }
    componentWillUnmount() {
        this.unlistenHistory();
    }
    render() {
        let common = [
            <Route key="user_agreement" path="/user_agreement" exact component={UserAgreement} />,
            <Route key="privacy_statement" path="/privacy_statement" exact component={PrivacyStatement} />,
            <Route key="get_most" path="/get_most" exact component={GetMost} />,
            <Route key="login/linkedin" path="/login/linkedin" exact component={LoginViaLinkedin} />,
            <Route key="add/code" path="/add/:code" exact component={AddEventWithCode} />,
        ];

        // NOTE: /notification route (singular) added to match native app
        // TODO: make sure /notifications is not needed anymore and use just /notification

        return (
            <Router history={app.history}>
                <StyleVariables />
                <I18nSwitcher />
                {this.props.session.hasUser ? (
                    <>
                        <LoadUserEvents key={this.props.session.user.id}>
                            <LoadUpdates>
                                <SidePanel containerSelector="#splitScreen" />
                                <Switch>
                                    {common}
                                    <Route path="/chats" component={globalChatRoutes} />
                                    <Route path="/new_account" exact component={NewAccount} />
                                    <Route path="/add" exact component={AddEventCode} />
                                    <Route path="/events/missing_code" exact component={MissingCode} />
                                    <Route path="/my_profile" component={profileRoutes} />
                                    <Route path="/archive" exact component={Archive} />
                                    <Route path="/notification" component={notificationRoutes} />
                                    <Route path="/notifications" component={notificationRoutes} />
                                    <Route path="/events/:eventId" component={eventRoutes} />
                                    <Route path="/contacts" component={globalContactsRoutes} />
                                    <Route path="/login/linkedin/account" exact component={LinkedinNewAccount} />,
                                    <Route path="/login/linkedin/account/name" exact component={MyProfileScreen_Edit} />,
                                    <Route path="/login/linkedin/account/email" exact component={MyProfileScreen_Email} />,
                                    <Route path="/" exact component={MainScreen} />
                                    <Redirect to="/" />
                                </Switch>
                            </LoadUpdates>
                        </LoadUserEvents>
                        <RedirectToStoredPathname />
                    </>
                ) : (
                    <Switch>
                        {common}
                        <Route path="/register" exact component={Registration} />
                        <Route path="/login" exact component={Login} />
                        <Route path="/login/email" exact component={LoginViaEmail} />
                        <Route path="/password_recover" exact component={PasswordRecover} />
                        <Route path="/" exact component={Welcome} />
                        <Route component={UnauthenticatedRedirection} />
                    </Switch>
                )}
            </Router>
        );
    }
    handleRouteChange(location) {
        console.log(`Navigation: ${location.pathname}`);
        app.store.dispatch(app.actions.ui.navigation(location.pathname));
    }
}

export default connect((state, props) => ({
    session: state.session,
}))(AppRoutes);
